const getServerURL = () => {
  return (
    process.env.REACT_APP_API_SERVER ||
    'https://startplus-dev1.us-west-2.dev.aws.castandcrew.com'
  );
};

module.exports = getServerURL;
